import { splitJoin } from '../helper/TextHelper';
import { isObjectEmpty } from '../helper/DataHelper';
import { JobType, Meter } from '../redux/jobs/jobs.types';
import { FieldVisibility, hasVisibleField } from './fieldVisibility';

// Die Typen kommen aus dem Auftragsmodell statt aus eigenen Schnittstellen:
// beide sind dort inline deklariert, und eine Kopie hier wäre eine zweite
// Wahrheit, die bei einer Modelländerung stillschweigend auseinanderläuft.
type MeterAddress = NonNullable<Meter['meterAddress']>;
type Customer = JobType['customer'];

/**
 * Die Anschrift-Zeile des Auftragsdetails. Herausgezogen aus JobDetails, weil
 * sie als einzige Stelle im Portal gegen den KUNDEN entdoppelt — steht dort
 * dieselbe Firma oder derselbe Name, wird er in der Anschrift weggelassen.
 *
 * Der Namensblock hat einen eigenen Vorbau: pick() leert nur den INHALT, es
 * entscheidet nicht über den Wächter. Ohne den Vorbau baute eine versteckte
 * Anschrift-Firma weiter einen (dann leeren) Namensblock.
 */
export function readableMeterAddress(
    address: MeterAddress | undefined,
    customer: Customer | undefined,
    visibility: FieldVisibility,
): string | null {
    if (!address || isObjectEmpty(address)) return null;

    const showsPerson = hasVisibleField(visibility, [
        'meter.meterAddress.company',
        'meter.meterAddress.firstname',
        'meter.meterAddress.lastname',
    ]);

    let companyFullName: string | null = null;

    if (showsPerson && (address.company || (address.firstname && address.lastname))) {
        const company =
            address.company === customer?.company
                ? null
                : visibility.pick('meter.meterAddress.company', address.company);

        const fullName =
            address.firstname === customer?.firstname && address.lastname === customer?.lastname
                ? null
                : splitJoin(
                      ', ',
                      visibility.pick('meter.meterAddress.firstname', address.firstname),
                      visibility.pick('meter.meterAddress.lastname', address.lastname),
                  );

        companyFullName = splitJoin(', ', company, fullName);
    }

    return splitJoin(
        ', ',
        companyFullName,
        splitJoin(
            ' ',
            visibility.pick('meter.meterAddress.street', address.street),
            visibility.pick('meter.meterAddress.houseNumber', address.houseNumber),
        ),
        splitJoin(
            ' ',
            visibility.pick('meter.meterAddress.zip', address.zip),
            visibility.pick('meter.meterAddress.city', address.city),
        ),
    );
}
